import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { ControlProps, CSSObjectWithLabel, GroupBase } from 'react-select'
import { OptionType } from '@/app/utils/optionSelectType'
import { BasicSelect } from '@/view/components/BasicSelect'
import { customerStatusType } from '@/app/utils/customerStatusType'

export default function SortByCustomerStatus() {
  const {
    formState: { errors },
  } = useFormContext<FilterFormData>()

  //   const handleSelectCustomerStatus = (
  //     selectedCustomerStatus: SingleValue<OptionType>,
  //   ) => {
  //     if (selectedCustomerStatus !== null) {
  //         setValue('customerStatus', selectedCustomerStatus.value)
  //         setOpt(selectedCustomerStatus)
  //       }
  //   }

  const customStyles = {
    control: (
      base: CSSObjectWithLabel,
      props: ControlProps<OptionType, false, GroupBase<OptionType>>,
    ): CSSObjectWithLabel => ({
      ...base,
      borderRadius: '6px',
      border: props.isFocused
        ? '2px solid black'
        : '1px solid hsl(var(--input))',
      boxShadow: 'black',
      '&:hover': {
        border: '1px solid hsl(var(--input))',
      },
      backgroundColor: 'white',
    }),
    placeholder: (base: CSSObjectWithLabel) => ({
      ...base,
      color: 'black',
    }),
  }

  return (
    <div className={'space-y-2'}>
      <h3 className="font-medium text-black04">Status do cliente</h3>
      <BasicSelect
        name="customerStatus"
        options={customerStatusType}
        styles={customStyles}
        placeholder="Selecione o status do cliente"
        error={errors.customerStatus?.message}
      />
    </div>
  )
}
